// react
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function ProductCardSkeleton(props) {
    const { layout } = props;
    const containerClasses = classNames('product-card product-card--skeleton', {
        'product-card--layout--grid product-card--size--nl': !layout || layout === 'grid-nl',
        'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
        'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    });

    return (
        <div className={containerClasses} aria-hidden="true">
            <div className="product-card__image">
                <div className="skeleton-bone skeleton-bone--image" />
            </div>
            <div className="product-card__info">
                <div className="skeleton-bone skeleton-bone--text skeleton-bone--w-90" />
                <div className="skeleton-bone skeleton-bone--text skeleton-bone--w-60" />
            </div>
            <div className="product-card__actions">
                <div className="skeleton-bone skeleton-bone--price" />
                <div className="skeleton-bone skeleton-bone--badge" style={{ marginTop: 4 }} />
            </div>
        </div>
    );
}

ProductCardSkeleton.propTypes = {
    layout: PropTypes.string,
};
